module.exports = __webpack_public_path__ + "static/media/BargicideCOVID19Certificate.9858ed67.png";